import { render, staticRenderFns } from "./DeviceAwake.vue?vue&type=template&id=28aedc6a&scoped=true&"
import script from "./DeviceAwake.vue?vue&type=script&lang=js&"
export * from "./DeviceAwake.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAwake.vue?vue&type=style&index=0&id=28aedc6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aedc6a",
  null
  
)

export default component.exports